import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Globe, X } from "lucide-react";
import { useLang } from "../i18n";
import { isEnPath, toEnPath } from "../langRouting";

const DISMISS_KEY = "parasyo-lang-banner";

// Tesla/Apple modeli: IP bazlı OTOMATİK yönlendirme YOK (Googlebot'un TR içeriği
// indeksleyebilmesi için kök adres herkese sabit Türkçe sunulur). Yabancı ziyaretçiye
// bunun yerine kapatılabilir bir dil öneri bandı gösterilir.
export const LangBanner = () => {
  const { isForeign, geoResolved, setLang } = useLang();
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let dismissed = null;
    let pref = null;
    try {
      dismissed = localStorage.getItem(DISMISS_KEY);
      pref = localStorage.getItem("parasyo-lang");
    } catch { /* yoksay */ }
    const show = geoResolved && isForeign && !isEnPath(location.pathname) && !location.pathname.startsWith("/admin") && !pref && !dismissed;
    if (!show) {
      setVisible(false);
      return undefined;
    }
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, [geoResolved, isForeign, location.pathname]);

  if (!visible) return null;

  const switchToEn = () => {
    try { localStorage.setItem(DISMISS_KEY, "en"); } catch { /* yoksay */ }
    setLang("en");
    navigate(toEnPath(location.pathname));
    setVisible(false);
  };
  const close = () => {
    try { localStorage.setItem(DISMISS_KEY, "dismissed"); } catch { /* yoksay */ }
    setVisible(false);
  };

  return (
    <div data-testid="lang-banner" className="fixed bottom-4 left-4 z-50 max-w-xs rounded-2xl border border-black/10 bg-white p-4 shadow-2xl">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-operofy-blue/10 text-operofy-blue">
          <Globe size={17} strokeWidth={2} />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-bold text-black">This site is also available in English</p>
          <p className="mt-0.5 text-xs leading-relaxed text-black/55">English version with USD pricing.</p>
          <button
            onClick={switchToEn}
            data-testid="lang-banner-switch"
            className="mt-2.5 inline-flex items-center gap-1.5 rounded-full bg-operofy-blue px-4 py-2 text-xs font-extrabold text-white transition-colors hover:bg-operofy-bluehover active:scale-95"
          >
            View in English
          </button>
        </div>
        <button onClick={close} data-testid="lang-banner-close" aria-label="Close language suggestion" className="shrink-0 rounded-full p-1 text-black/35 transition-colors hover:text-black">
          <X size={15} />
        </button>
      </div>
    </div>
  );
};
